"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const Title_1 = __importDefault(require("antd/lib/typography/Title"));
const react_1 = __importStar(require("react"));
const FormSuite_1 = require("../../hooks/FormSuite");
const genCheckinCheckout_1 = require("../../pages/paymentBooking/genCheckinCheckout");
const suiteFormStyle_1 = require("../suiteCollapse/suiteForm/suiteFormStyle");
const TelephoneStyle_1 = require("../telephone/TelephoneStyle");
require("./CheckInCheckOutStyles.scss");
const CHECKINSTART = '15:00';
const CHECKINLIMIT = '06:00';
const CHECKOUTSTART = '06:00';
const CHECKOUTLIMIT = '12:00';
const CheckinCheckout = ({ field, formKey = 'suites' }) => {
    const { form } = (0, FormSuite_1.useFormSuit)();
    const [checkinList, setCheckinList] = (0, react_1.useState)([]);
    const [checkoutList, setCheckoutList] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        setCheckinList((0, genCheckinCheckout_1.genListTime)(CHECKINSTART, CHECKINLIMIT));
        setCheckoutList((0, genCheckinCheckout_1.genListTime)(CHECKOUTSTART, CHECKOUTLIMIT));
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(antd_1.Divider, null),
        react_1.default.createElement(Title_1.default, { level: 5 }, "Check-In | Check-Out"),
        react_1.default.createElement(antd_1.Row, { justify: "space-between" },
            react_1.default.createElement(antd_1.Col, { xs: {
                    span: 24,
                    flex: '1',
                }, sm: {
                    span: 24,
                    flex: '1',
                }, lg: 11 },
                react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: [field.name, 'checkInTime'], label: "Hor\u00E1rio previsto de chegada", style: { color: '#000' }, rules: [
                        {
                            required: true,
                        },
                    ] },
                    react_1.default.createElement(TelephoneStyle_1.SelectStyled, { placeholder: "Selecione o hor\u00E1rio previsto de check-in" }, checkinList.map(item => (react_1.default.createElement(TelephoneStyle_1.SelectStyled.Option, { value: item.value, key: item.value }, item.label)))))),
            react_1.default.createElement(antd_1.Col, { xs: {
                    span: 24,
                    flex: '1',
                }, sm: {
                    span: 24,
                    flex: '1',
                }, lg: 11 },
                react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: [field.name, 'checkOutTime'], label: "Hor\u00E1rio previsto de sa\u00EDda", rules: [
                        {
                            required: true,
                        },
                    ] },
                    react_1.default.createElement(TelephoneStyle_1.SelectStyled, { placeholder: "Selecione o hor\u00E1rio previsto de check-out" }, checkoutList.map(item => (react_1.default.createElement(TelephoneStyle_1.SelectStyled.Option, { value: item.value, key: item.value }, item.label)))))))));
};
exports.default = CheckinCheckout;
